import React, {useState} from "react";
import {ProfileImage} from "../common/profile-image";
import TextMore from "../common/text-more";
import Awards from "./about-awards";
import {industryById, industryLabelById} from "../../../utils/industry";
import {
    useGetIndustryQuery,
    useGetLocationQuery,
    useGetSkillQuery,
    useGetWorkQuery,
    useUpdateAgencyMutation
} from "../../../store/api/api";
import {skillLabelById} from "../../../utils/skill";
import AboutAwards from "./about-awards";
import {EditIcon} from "../common/icons/edit-icon"
import {AboutPopup} from "./popup/about-popup";
import {DiversityPopup} from "./popup/diversity-popup";
import {YearFoundedPopup} from "./popup/year-founded-popup";
import {IndustryPopup} from "./popup/industry-popup";
import {LocationPopup} from "./popup/location-popup";

export default function AgencyAbout({agency,projects,awards,edit}) {

    const [showAboutPopup, setShowAboutPopup] = useState(false);
    const [showDiversityPopup, setShowDiversityPopup] = useState(false);
    const [showYearFoundedPopup, setShowYearFoundedPopup] = useState(false);
    const [showLocationPopup, setShowLocationPopup] = useState(false);
    const [showIndustryPopup, setShowIndustryPopup] = useState(false);

    // load agency projects
    const {data: industryData, error: industryError, isLoading: industryIsLoading} = useGetIndustryQuery();
    const {data: skillData, error: skillError, isLoading: skillIsLoading} = useGetSkillQuery();
    const { data: locationLookupData, error: locationLookupError, isLoading: locationLookupIsLoading } = useGetLocationQuery();
    const [ updateAgency,  { isLoading: isUpdating }] = useUpdateAgencyMutation();

    console.log("agency",agency)
    function onAboutSave(text) {
        updateAgency({
            "agency_id":agency.agency_id,
            "about":text,
        })
        setShowAboutPopup(false)
    }

    function onDiversitySave(diversity) {
        let ids = diversity.map(obj => obj.diversity_id)

        updateAgency({
            "agency_id":agency.agency_id,
            "diversity":ids,
        })
        setShowDiversityPopup(false)
    }

    function onLocationSave(location) {
        updateAgency({
            "agency_id":agency.agency_id,
            "location":location,
        })
        setShowLocationPopup(false)
    }

    function onYearFoundedSave(yearFounded) {

        updateAgency({
            "agency_id":agency.agency_id,
            "year_founded":yearFounded,
        })
        setShowYearFoundedPopup(false)
    }

    function onIndustrySave(industry) {
        //let ids = diversity.map(obj => obj.diversity_id)

        updateAgency({
            "agency_id":agency.agency_id,
            "industries":industry,
        })
        setShowDiversityPopup(false)
    }

    return (
       <div className="grid grid-cols-2 gap-16 mobile:grid-cols-1">
           <div className="flex flex-col gap-16">
              {/* About */}
              <div>
                  <span className="flex justify-between text-[14px] leading-[18.2px] dark:text-[#A3A3A3] text-[#808080] tracking-[-0.03em]">About
                      {edit && <div className="hover:cursor-pointer" onClick={() => setShowAboutPopup(true)}><EditIcon/></div>}
                  </span>
                  <TextMore len={250}>
                    {agency.about}
                  </TextMore>
              </div>

               {/* Diversity */}
               <div>
                  <span className="flex justify-between text-[14px] leading-[18.2px] dark:text-[#A3A3A3] text-[#808080] tracking-[-0.03em]">Diversity Edge
                      {edit && <div className="hover:cursor-pointer" onClick={() => setShowDiversityPopup(true)}><EditIcon/></div>}
                  </span>
                  <div className="py-2 pb-4 text-2xl font-semibold">
                      {agency.diversity.map(obj => obj.label ).join(', ')}
                  </div>
               </div>
               <div>
               {/* Skills */}
                   <span className="flex justify-between text-[14px] leading-[18.2px] dark:text-[#A3A3A3] text-[#808080] tracking-[-0.03em]">Primary Skills
                       {edit && <EditIcon/>}
                   </span>
                   <div className="py-2 pb-4 text-2xl font-semibold">
                       {skillIsLoading===false && agency.skills.map(obj => skillLabelById(skillData.data,obj.skill_id)).join(', ')}
                   </div>
               </div>
               <div>
                 {/* Industries */}
                 <span className="flex justify-between text-[14px] leading-[18.2px] dark:text-[#A3A3A3] text-[#808080] tracking-[-0.03em]">Primary Industries
                     {edit && <div className="hover:cursor-pointer" onClick={() => setShowIndustryPopup(true)}><EditIcon/></div>}
                 </span>
                 <div className="py-2 pb-4 text-2xl font-semibold">
                    {industryIsLoading===false && agency.industries.map(obj => industryLabelById(industryData.data,obj.industry_id)).join(', ')}
                 </div>
               </div>
               <div>
                  {/* Roles */}
                  {agency.roles && <span className="flex justify-between text-[14px] leading-[18.2px] dark:text-[#A3A3A3] text-[#808080] tracking-[-0.03em]">Roles
                      {edit && <EditIcon/>}
                  </span>}
                   {agency.roles && (<div className="py-2 pb-4 text-2xl font-semibold">
                   {agency.roles.map(obj => obj.role_id ).join(', ')}
                                           </div>)}
               </div>


           </div>

           <div className="flex flex-col gap-16">
               {/* Leaders */}
               <div>
                   <span className="flex justify-between text-[14px] leading-[18.2px] dark:text-[#A3A3A3] text-[#808080] tracking-[-0.03em]">Agency Leaders
                       {edit && <EditIcon/>}
                   </span>

                   <div className="py-4 flex gap-[24px]">
                       {agency.leaders.map((data, id) => {
                           return (
                               <div key={id} className="flex flex-col justify-center gap-[12px]">
                                   <div className="w-[150px] h-[150px]">
                                       <ProfileImage url={data.profile_avatar_url ? data.profile_avatar_url : "data:image/png;base64,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"} />
                                   </div>
                                   <span className='font-bold mb-[16px] text-transform: capitalize archivo text-[#1D1D1d] text-[24px] dark:text-[#FFFFFF]'>{data.fullname}</span>
                               </div>
                           )
                       })}
                   </div>
               </div>

               {/* Awards */}
               <AboutAwards awards={awards}/>
                <div>
                   {/* Location */}
                   <span className="flex justify-between text-[14px] leading-[18.2px] dark:text-[#A3A3A3] text-[#808080] tracking-[-0.03em]">Location
                       {edit && <div className="hover:cursor-pointer" onClick={() => setShowLocationPopup(true)}><EditIcon/></div>}
                   </span>
                   <div className="py-2 pb-4 text-2xl font-semibold uppercase">
                       {agency.location ?locationLookupIsLoading ?agency.location: locationLookupData.data.find(loc => loc.location_id===agency.location).label: '-'}
                   </div>
               </div>
               <div>
                   {/* Year founded */}
                   <span className="flex justify-between text-[14px] leading-[18.2px] dark:text-[#A3A3A3] text-[#808080] tracking-[-0.03em]">Years Founded
                       {edit && <div className="hover:cursor-pointer" onClick={() => setShowYearFoundedPopup(true)}><EditIcon/></div>}
                   </span>
                   <div className="py-2 pb-4 text-2xl font-semibold">
                       {agency.year_founded}
                   </div>
               </div>
               {showAboutPopup && <AboutPopup text={agency.about} onCancel={() => setShowAboutPopup(false)} onSave={onAboutSave} close={() => {setShowAboutPopup(false);document.body.classList.remove("overflow-y-hidden")}} />}
               {showDiversityPopup && <DiversityPopup diversity={agency.diversity} onCancel={() => setShowDiversityPopup(false)} onSave={onDiversitySave} close={() => {setShowDiversityPopup(false);document.body.classList.remove("overflow-y-hidden")}} />}
               {showYearFoundedPopup && <YearFoundedPopup year={agency.year_founded} onCancel={() => setShowYearFoundedPopup(false)} onSave={onYearFoundedSave} close={() => {setShowYearFoundedPopup(false);document.body.classList.remove("overflow-y-hidden")}} />}
               {showLocationPopup && <LocationPopup location={agency.location} onCancel={() => setShowLocationPopup(false)} onSave={onLocationSave} close={() => {setShowLocationPopup(false);document.body.classList.remove("overflow-y-hidden")}} />}
               {showIndustryPopup && <IndustryPopup industry={agency.industries} onCancel={() => setShowIndustryPopup(false)} onSave={onIndustrySave} close={() => {setShowIndustryPopup(false);document.body.classList.remove("overflow-y-hidden")}} />}
           </div>


       </div>)
}
